import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { NgbRatingConfig } from '@ng-bootstrap/ng-bootstrap';
import { LayoutService } from './shared/services/layout.service';
import { BackToTopComponent } from "./shared/components/ui/back-to-top/back-to-top.component";
import { Title } from '@angular/platform-browser';
import { filter, map } from 'rxjs';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet,NgxSpinnerModule, BackToTopComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})

export class AppComponent {

  constructor(private config: NgbRatingConfig,
    public layoutService: LayoutService,
    private router: Router,
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private swUpdate: SwUpdate,
    private toastr: ToastrService) {
    this.config.max = 5;
    this.config.readonly = true;
  }

  ngOnInit() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let route = this.activatedRoute.firstChild;
          while (route?.firstChild) {
            route = route.firstChild;
          }

          const pageTitle = route?.snapshot.data['pageTitle'] || route?.snapshot.data['title'];
          return pageTitle ? `${pageTitle} | AeroVera IQ` : 'AeroVera IQ';
        })
      )
      .subscribe(title => {
        this.titleService.setTitle(title);
      });

    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates
        .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
        .subscribe(() => {
          const toast = this.toastr.info('A new version of AeroVera IQ is available. Click to reload.', 'Update Available', {
            tapToDismiss: true,
            disableTimeOut: true
          });
          toast.onTap.subscribe(() => document.location.reload());
        });
    }
  }

}
